import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import NamedRecoveriesTable from "components/recoveries/named-recoveries/named-recoveries-table"
// Data
import { alphanum } from "components/table/lib/sort"
import api_match from "data/interface/api"
import areaMeasuresService from 'data/area-measures'
import increaseService from 'data/increase'
import inflationService from 'data/inflation'
import propertyService from 'data/property'
import recoveryService from "data/named-recovery"
import recoveryPoolsService from 'data/recovery-pools'
import reportTagService from 'data/report-tag'
import validationService from 'data/validate'
import { WithTip } from 'components/tooltip/with-tip'
import toggles from "feature-toggles"
//Styles
import { AddIcon } from "images/icons/tools"

import { ContextRow } from './named-recoveries-table'

const NamedRecoveries: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [areas, setAreas] = useState<object[]>([])
  const [increase, setIncrease] = useState<object[]>([])
  const [inflation, setInflation] = useState<object[]>([])
  const [pools, setPools] = useState<object[]>([])
  const [reportTags, setReportTags] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [showSelected, setShowSelected] = useState<boolean>(false)
  const [selected, setSelected] = useState<ContextRow[]>([]);
  const tableId = "named-recoveries-table"

  useEffect(() => {

    const areaMeasuresSubscription = areaMeasuresService.stream().subscribe(data => {
      api_match(
        data,
        init  => setAreas(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setAreas([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setAreas(ok.value)
          }
        },
        err   => {
          setAreas(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const increaseSubscription = increaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setIncrease(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setIncrease([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setIncrease(ok.value)
          }
        },
        err   => {
          setIncrease(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflation(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setInflation([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setInflation(ok.value)
          }
        },
        err   => {
          setInflation(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        setProperty(currentProperty);
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    const recoverySubscription = recoveryService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          if(!initSort && ok.value.length) { // sort only on first load
            setData([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
            setInitSort(true)
          } else {
            setData(ok.value)
          }
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const recoveryPoolsSubscription = recoveryPoolsService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPools(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setPools([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setPools(ok.value)
          }
        },
        err   => {
          setPools(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const reportTagSubscription = reportTagService.stream().subscribe(data => {
      api_match(
        data,
        init  => setReportTags(init.value),
        ok    => {
          if(!initSort && ok.value.length) {
            setReportTags([...ok.value].sort((a, b) => alphanum(_.get(a, "code"), _.get(b, "code"))))
          } else {
            setReportTags(ok.value)
          }
        },
        err   => {
          setReportTags(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      areaMeasuresSubscription.unsubscribe()
      increaseSubscription.unsubscribe()
      inflationSubscription.unsubscribe()
      propertySubscription.unsubscribe()
      recoverySubscription.unsubscribe()
      recoveryPoolsSubscription.unsubscribe()
      reportTagSubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    areaMeasuresService.fetchAreaMeasures(propertyId)
    increaseService.fetchIncrease(propertyId)
    inflationService.fetchInflation(propertyId)
    propertyService.fetchProperty(propertyId)
    recoveryService.fetchRecoveries(propertyId)
    recoveryPoolsService.fetchRecoveryPools(propertyId)
    reportTagService.fetchReportTags(propertyId)

  }, [propertyId])

  useEffect(() => {
    propertyService.fetchProperty(propertyId)
  }, [data])

  const Add = () => {
    return (
      <a onClick={() => recoveryService.create(propertyService.getStoredPropertyId())}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  const [deleteFlag, setDeleteFlag] = useState(0)
  const Delete = () => {
    return (
      <WithTip position="bottom">
        <span>Delete Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput')  ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setDeleteFlag(deleteFlag+1)
        }}>
          <span className="p-menuitem-icon pi pi-fw pi-trash"></span>
        </a>
      </WithTip>
    )
  }

  const [pasteFlag, setPasteFlag] = useState(0)
  const Paste = () => {
    return (
      <WithTip position="bottom">
        <span>Paste to Selected Rows</span>
        <a className={selected.length && !_.some(selected, 'systeminput') ? '' : 'disabled'}
          onClick={() => {
            if (!selected.length || _.some(selected, 'systeminput')) return
            setPasteFlag(pasteFlag+1)
          }
        }>
          <span className="p-menuitem-icon pi pi-fw pi-clone"></span>
        </a>
      </WithTip>
    )
  }

  const ShowSelected = () => (
    <WithTip position="bottom">
      <span>Show {showSelected ? 'All' : 'Selected'} Rows</span>
      <a className={selected.length ? '' : 'disabled'}
        onClick={() => {
          if (!selected.length) return
          setShowSelected(!showSelected)
        }}>
        <span className={showSelected ? 'pi pi-eye-slash' : 'pi pi-eye'} style={{height: '18px', width: '18px'}}></span>
      </a>
    </WithTip>
  )

  useEffect(() => {
    setSelected(_.intersectionBy(data, selected, 'recoveryid'))
  }, [data])

  useEffect(() => {
    if (showSelected && _.isEmpty(selected)) setShowSelected(false)
  }, [selected])

  const _data = showSelected ? selected : data

  return (
    <div>
      <Toolbar>
        <Add />
        {toggles.multiselect() && <>
          <Paste />
          <Delete />
          <ShowSelected />
        </>}
      </Toolbar>
      { data && property && pools && areas && reportTags && inflation && increase && <NamedRecoveriesTable tableId={tableId} data={_data} property={property} recoveryPools={pools} areaMeasures={areas} inflations={inflation} increases={increase} reportTags={reportTags} selectedState={[selected, setSelected]} flags={{deleteFlag, pasteFlag}}/> }
    </div>
  )
}

export default NamedRecoveries
